import { render, staticRenderFns } from "./open_cart.vue?vue&type=template&id=02720d36&scoped=true&"
import script from "./open_cart.vue?vue&type=script&lang=js&"
export * from "./open_cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02720d36",
  null
  
)

export default component.exports